function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 1a11 11 0 1011 11A11 11 0 0012 1zm-2 13.89l-2.65-2.68-.7.7 3.35 3.4L17.35 9l-.7-.7z",
  fill: "#00708d"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.04 14.89l-2.69-2.68-.7.7 3.39 3.4 7.31-7.32-.7-.7-6.61 6.6z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "icon"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0ic2VsZWN0LWxheWVyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDcwOGQ7fS5jbHMtMntmaWxsOm5vbmU7fS5jbHMtM3tmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJzZWxlY3QiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEyLDFBMTEsMTEsMCwxLDAsMjMsMTIsMTEsMTEsMCwwLDAsMTIsMVpNMTAsMTQuODksNy4zNSwxMi4yMWwtLjcuN0wxMCwxNi4zMSwxNy4zNSw5bC0uNy0uN1oiLz48cmVjdCBjbGFzcz0iY2xzLTIiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPjwvZz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTAuMDQgMTQuODkgNy4zNSAxMi4yMSA2LjY1IDEyLjkxIDEwLjA0IDE2LjMxIDE3LjM1IDguOTkgMTYuNjUgOC4yOSAxMC4wNCAxNC44OSIvPjwvc3ZnPg==";
export { SvgCheck as ReactComponent };